export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9489.b5e0e8b6.jpg";